import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldModule } from '@angular/material/form-field';
import {MatTooltipModule, TooltipPosition} from '@angular/material/tooltip';

import { AllappsComponent } from './allapps/allapps.component';
import { AppComponent } from './app.component';
import { AppDetailsModalComponent } from './app-details-modal/app-details-modal.component';
import { AppRoutingModule } from './app-routing.module';
import { ArrayTypeComponent } from './array.type';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { BusinessTermComponent } from './business-term/business-term.component';
import { ClassificationComponent } from './classification/classification.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DndModule } from 'ngx-drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DynamicComponent } from './dynamic/dynamic.component';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule } from '@angular/common/http';
import {MatBadgeModule} from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table'
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MultiSchemaTypeComponent } from './multischema.type';
import { NewDataEngComponent } from './new-data-eng/new-data-eng.component';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxGraphModule } from '@swimlane/ngx-graph';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NullTypeComponent } from './null.type';
import { ObjectTypeComponent } from './object.type';
import { PhyFileComponent } from './phy-file/phy-file.component';
import { SecurityModule } from 'security';
import { SidenavComponent } from './sidenav/sidenav.component';
import { SvmCruduiModule } from 'svm-crudui';
import {SvmHierModule} from 'svm-hier'
import { HierComponent } from './hier/hier.component';

//import { PaginationComponent } from './pagination/pagination.component';



//import { DataEngineeringComponent } from './data-engineering/data-engineering.component';




// import { UserAppComponent } from './user-app/user-app.component';
export function minItemsValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should NOT have fewer than ${field.props['minItems']} items`;
}

export function maxItemsValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should NOT have more than ${field.props['maxItems']} items`;
}

export function minLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should NOT be shorter than ${field.props.minLength} characters`;
}

export function maxLengthValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should NOT be longer than ${field.props.maxLength} characters`;
}

export function minValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be >= ${field.props.min}`;
}

export function maxValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be <= ${field.props.max}`;
}

export function multipleOfValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be multiple of ${field.props.step}`;
}

export function exclusiveMinimumValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be > ${field.props.step}`;
}

export function exclusiveMaximumValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be < ${field.props.step}`;
}

export function constValidationMessage(error: any, field: FormlyFieldConfig) {
  return `should be equal to constant "${field.props['const']}"`;
}

export function typeValidationMessage({ schemaType }: any) {
  return `should be "${schemaType[0]}".`;
}

@NgModule(
  {
    declarations: [
      AppComponent,
      HeaderComponent,
      HomeComponent,
      DashboardComponent,
      SidenavComponent,
    //  DataEngineeringComponent,
 
      DynamicComponent,
      NewDataEngComponent,
      AppDetailsModalComponent,
      PhyFileComponent,
      AllappsComponent,
      BusinessTermComponent,
      ClassificationComponent,
      NullTypeComponent,
      ArrayTypeComponent,
      ObjectTypeComponent,
      MultiSchemaTypeComponent,
      HierComponent
    //  PaginationComponent
    ],
    imports: [
      BrowserModule,
      AppRoutingModule,
      BrowserAnimationsModule,
      HttpClientModule,
      // * MATERIAL IMPORTS
      FormsModule,
      NgxGraphModule,
      ReactiveFormsModule,
      SecurityModule,
      MatSidenavModule,
      MatToolbarModule,
      MatMenuModule,
      MatIconModule,
      MatDividerModule,
      MatListModule,
      MatCardModule,
      MatInputModule,
      MatFormFieldModule,
      MatTabsModule,
      MatSelectModule,
      MatRadioModule,
      MatExpansionModule,
      FormsModule,

      MatTableModule,
      MatGridListModule,
      //SecurityModule,
      MatSnackBarModule,
      MatButtonModule,
      MatCheckboxModule,
      MatSortModule,
      MatDialogModule,
      DragDropModule,
      SvmCruduiModule,
      MatButtonToggleModule,
      NgSelectModule,
      MatSlideToggleModule,
      MatStepperModule,
      MatTooltipModule,
      DndModule,
      NgxSpinnerModule,
      MatBadgeModule,
      SvmHierModule,
   
      FormlyModule.forRoot({
        validationMessages: [
          { name: 'required', message: 'This field is required' },
          { name: 'type', message: typeValidationMessage },
          { name: 'minLength', message: minLengthValidationMessage },
          { name: 'maxLength', message: maxLengthValidationMessage },
          { name: 'min', message: minValidationMessage },
          { name: 'max', message: maxValidationMessage },
          { name: 'multipleOf', message: multipleOfValidationMessage },
          { name: 'exclusiveMinimum', message: exclusiveMinimumValidationMessage },
          { name: 'exclusiveMaximum', message: exclusiveMaximumValidationMessage },
          { name: 'minItems', message: minItemsValidationMessage },
          { name: 'maxItems', message: maxItemsValidationMessage },
          { name: 'uniqueItems', message: 'should NOT have duplicate items' },
          { name: 'const', message: constValidationMessage },
          { name: 'enum', message: `must be equal to one of the allowed values` },
        ],
        types: [
          
       
          { name: 'null', component: NullTypeComponent, wrappers: ['form-field'] },
          { name: 'array', component: ArrayTypeComponent },
          { name: 'object', component: ObjectTypeComponent },
          { name: 'multischema', component: MultiSchemaTypeComponent },
         
        ]
      
     
      }),
      FormlyMaterialModule
     ],

    providers: [
      // {provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: {appearance: 'outline'}}
    ]
    ,
    bootstrap: [AppComponent],
  })
export class AppModule { }
